

import React, { memo } from 'react';
import cx from 'classnames';
import onEnterPressed from '@shootsta/on-enter-pressed';
import { Text, Icon } from '../../../ui-kit';

import '../styles/_menu-item.scss';

function MenuItem(props) {
  const {
    onClick,
    label = '',
    withSeparator,
    hasSubmenu,
    icon,
    selected,
    disabled
  } = props;

  const id = `nav-item-${label.replace(/\s/g, '').toLowerCase()}`;

  return (
    <>
      <div
        id={id}
        data-cy={id}
        className={cx('menu-item', { 'menu-item--selected': selected })}
        onClick={onClick}
        tabIndex={0}
        role="button"
        onKeyPress={onEnterPressed({ onClick })}>

        <>
          {icon &&
          <Icon
            className="menu-item__text-prefix-icon"
            name={icon}
            size={20} />}


          <Text
            noMargin
            className="menu-item__text"
            disabled={disabled}>

            {label}
          </Text>
          {hasSubmenu &&
          <Icon
            className="submenu-icon"
            name="chevronright"
            color="denim"
            size={16} />}


        </>
      </div>
      {withSeparator &&
      <hr key={`key-${id}`} className="menu-item__separator" />}

    </>);

}

export default memo(MenuItem);